import { render, staticRenderFns } from "./media.consumer.vue?vue&type=template&id=391c80f7&scoped=true&"
import script from "./media.consumer.vue?vue&type=script&lang=js&"
export * from "./media.consumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c80f7",
  null
  
)

export default component.exports